import { render, staticRenderFns } from "./PhotoEditor.vue?vue&type=template&id=27df75ce&scoped=true"
import script from "./PhotoEditor.vue?vue&type=script&lang=js"
export * from "./PhotoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df75ce",
  null
  
)

export default component.exports